import { render, staticRenderFns } from "./RemoveBtn.vue?vue&type=template&id=648e5e36&scoped=true&"
import script from "./RemoveBtn.vue?vue&type=script&lang=js&"
export * from "./RemoveBtn.vue?vue&type=script&lang=js&"
import style0 from "./RemoveBtn.vue?vue&type=style&index=0&id=648e5e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648e5e36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
